import { FC, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import {
	AlertDialog,
	AlertDialogBody,
	AlertDialogCloseButton,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogOverlay,
	Button,
	Flex,
} from '@bonusly/design-system';

interface DeleteUserSpotlightSectionModalProps {
	isOpen: boolean;
	onClose: () => void;
	onDelete: () => void;
	isDeleting?: boolean;
	sectionTitle?: string;
}

export const DeleteUserSpotlightSectionModal: FC<DeleteUserSpotlightSectionModalProps> = ({ isOpen, onClose, onDelete, isDeleting = false, sectionTitle }) => {
	const { t } = useTranslation('spotlight');
	const cancelRef = useRef<HTMLButtonElement>(null);

	return (
		<AlertDialog leastDestructiveRef={cancelRef} isOpen={isOpen} onClose={onClose} size="lg">
			<AlertDialogOverlay>
				<AlertDialogContent>
					<AlertDialogHeader fontSize="lg" fontWeight="bold">
						{t('deleteSectionModal.title')}
					</AlertDialogHeader>
					<AlertDialogCloseButton />

					<AlertDialogBody>
						{sectionTitle ? <Trans i18nKey="deleteSectionModal.bodyWithTitle" ns="spotlight" values={{ title: sectionTitle }} /> : t('deleteSectionModal.body')}
					</AlertDialogBody>

					<AlertDialogFooter>
						<Flex justify="space-between" w="full">
							<Button ref={cancelRef} onClick={onClose} variant="alpha" colorScheme="secondary" isDisabled={isDeleting}>
								{t('deleteSectionModal.cancel')}
							</Button>
							<Button colorScheme="danger" variant="solid" onClick={onDelete} isLoading={isDeleting}>
								{t('deleteSectionModal.remove')}
							</Button>
						</Flex>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialogOverlay>
		</AlertDialog>
	);
};
